"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CRM: 'CRM',
  SALES_HUB: 'SALES_HUB'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.3462/js/constants/SupportedPhoneNumberTypes.js
// module id = 644
// module chunks = 5 6